export const VLIBRAS_ELEMENT_ID = "sy-vlibras-element";
